module.exports = __webpack_public_path__ + "img/x.8bc183b3.png";